import React from 'react';
import NavigationTabPanelHeader from '../navigation-tab-panel-header/NavigationTabPanelHeader';
import { useNavigationTabPanelStyles } from './NavigationTabPanel.styles';

interface NavigationTabPanelProps {
  header: React.ReactElement<typeof NavigationTabPanelHeader>
  children: React.ReactNode
  footer?: React.ReactNode
}

const NavigationTabPanel: React.FC<NavigationTabPanelProps> = ({
  header,
  children,
  footer,
}) => {
  const styles = useNavigationTabPanelStyles();

  return (
    <div className={styles.container} data-testid="navigation-tab-panel">
      {header}
      {children}
      {footer}
    </div>
  );
};

export default NavigationTabPanel;
